import { useDispatch, useSelector } from 'react-redux'
import { ShowAllIndustryCheckbox } from '../../../../ShowAllIndustryCheckbox'
import {
  changeIsShowTradeData,
  selectIsShowTradeData,
} from '../../../store/slice'

export const ShowAllIndustry = () => {
  const dispatch = useDispatch()

  const isShow = useSelector(selectIsShowTradeData)

  const onClick = () => {
    dispatch(changeIsShowTradeData(!isShow))
  }

  return <ShowAllIndustryCheckbox isShow={isShow} onClick={onClick} />
}
